import { render } from "./TheFooter.vue?vue&type=template&id=54139e7d"
const script = {}

import exportComponent from "C:\\Projects\\svila\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__